export default {
  methods: {
    render_chart1(data) {
      console.log(data);
      let overviewData = {
        inLineTotalNum: data.inLineTotalNum,
        outLineTotalNum: data.outLineTotalNum
      }
      data = data.data;
      let option = {
          // title: {
          //     text: '按材质划分',
          //     top: 10,
          //     left: 10
          // },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999'
                  }
              }
          },
          legend: {
              data: ['未上架', '已上架'],
              top: 20,
              right: 20,
              width: 600,
              icon: 'rect',
              textStyle: {
                width: 300,
                padding: [2,0,0,0],
                rich: {
                  a: {
                    color: '#B4C3C0',
                    fontFamily: 'PingFangSC',
                  },
                  b: {
                    color: 'rgb(11,183,142)',
                    fontSize: 14,
                    fontFamily: 'PingFangSC',
                  }
                }
              },
              formatter: name=>{
                let value;
                if(name === '已上架') {
                  value = overviewData.inLineTotalNum || 0;
                }else{
                  value = overviewData.outLineTotalNum || 0;
                }
                return [
                  `{a|${name}} {a|总计}{b| ${value} }{a|个}`,
                ].join('\n')
              }
          },
          grid: {
            left: 20,
            bottom: 65,
            bottom: "25%",
            right: 20
          },
          xAxis: [
              {
                  type: 'category',
                  data: data.map(v=>v.category),
                  axisPointer: {
                      type: 'shadow',
                      label: {
                        show: false,
                      } 
                  },
                  axisTick: { show: false },
                  axisLabel: {
                    color: 'rgb(255,255,255,.6)',
                    fontFamily: 'PingFangSC',
                    interval: 0,
                    rotate: 45
                  },
                  axisLine: {
                    lineStyle: {
                      color: 'rgba(255,255,255,.15)',   
                    }
                  }
              }
          ],
          yAxis: [
              {
                  type: 'value',
                  show: false,
                  axisLabel: {
                    color: 'rgb(135,139,160)'
                  },
                  axisTick: { show: false },
                  axisLine: {
                    lineStyle: {
                      color: 'rgba(65,210,144,.3)',
                      fontFamily: 'PingFangSC',
                    }
                  },
                  splitLine: { show: false },
                  minInterval: 1
              }
          ],
          series: [
              {
                  name: '未上架',
                  type: 'bar',
                  data: [...data.map(v=>v.outLine)],
                  // itemStyle: {
                  //   color: 'rgb(11,183,142)',
                  //   barBorderRadius: [5,5,0,0]
                  // },
                  itemStyle: {
                    color: {
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        { offset: 0, color: '#5BE18D' },
                        { offset: 1, color: '#0FB498' }]
                    },
                    barBorderRadius: [5,5,0,0]
                  },
                  barWidth: 30,
                  label: {
                    show:  overviewData.outLineTotalNum == 0 ? false : true,
                    position: 'top',
                    distance: this.calcDistance(data),
                    color: 'rgb(11,183,142)'
                  }
              },
              {
                  name: '已上架',
                  type: 'line',
                  data: [...data.map(v=>v.inLine)],
                  itemStyle: {
                    color: 'rgb(250,137,0)'
                  },
                  label: {
                    show: true,
                    color: 'rgb(250,137,0)'
                  },
                  symbolSize: 10,
                  lineStyle: {
                    type: 'dotted'
                  }
              }
          ]
      };
      let $instance = this.$echarts.init(this.$refs['chart1']);
      $instance.setOption(option);
      $instance.on('click',params => {
        this.$router.push({
          path: '/newProduct/newproduct-process',
          query: {
            spuCategory: data.map(v=>v.category)[params.dataIndex],
            spuOnShelfFlag: params.seriesName == "已上架" ? 1 : 0
          }
        })
    });
    },
    calcDistance(data) {
      let distance;
      const offset = 15;
      const minVal = Math.min(...[...data.map(v=>v.outLine), ...data.map(v=>v.inLine)]);
      const maxVal = Math.max(...[...data.map(v=>v.outLine), ...data.map(v=>v.inLine)]);
      // 差值越大，distance值越大，偏移越大。差值越小，distance值越小。
      distance = (maxVal - minVal)*0.01 + offset
      return distance
    }
  }
}